import type { AlphaEarthIndex } from '@/features/map/types/map.types';

/** Một preset `palette` gửi lên `GET /api/alpha-earth/tiles` (F-AI-02). */
export interface AlphaEarthPalettePreset {
  palette: string;
  labelKey: string;
}

/**
 * Preset mặc định theo OpenAPI / F-AI-02. Thêm preset phụ khi có nguồn tài liệu rõ ràng.
 */
const SPECTRAL_PRESETS: Record<Exclude<AlphaEarthIndex, 'RGB'>, AlphaEarthPalettePreset[]> = {
  NDWI: [{ palette: 'white,blue', labelKey: 'flood.aoiInsight.palettePreset.fai02' }],
  MNDWI: [{ palette: 'white,blue', labelKey: 'flood.aoiInsight.palettePreset.fai02' }],
  NDVI: [{ palette: 'brown,yellow,green', labelKey: 'flood.aoiInsight.palettePreset.fai02' }],
  NDBI: [{ palette: 'white,red', labelKey: 'flood.aoiInsight.palettePreset.fai02' }],
  BAIS2: [{ palette: 'green,yellow,red', labelKey: 'flood.aoiInsight.palettePreset.fai02' }],
};

/**
 * Danh sách preset `palette` (theo F-AI-02) cho chỉ số phổ; RGB trả về mảng rỗng.
 */
export function getPalettePresetsForIndex(index: AlphaEarthIndex): AlphaEarthPalettePreset[] {
  if (index === 'RGB') return [];
  return SPECTRAL_PRESETS[index];
}

/** Chuỗi `palette` mặc định đầu tiên — dùng khi hydrate gallery và reset Select. */
export function getDefaultSpectralPaletteCsv(index: Exclude<AlphaEarthIndex, 'RGB'>): string {
  return SPECTRAL_PRESETS[index][0]?.palette ?? '';
}
